import React, { type FC } from 'react';
import { useLocation } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import urls from 'config/urls';

import ModalRoot from '../app-layout/modal-root/modal-root';
import PermanentNotificationsContainer
  from '../app-layout/permanent-notifications-container/permanent-notifications-container';

import './app-layout-embedded.scss';

const AppLayoutEmbedded: FC = ({ children }) => {
  const { pathname } = useLocation();
  const hideBannersOnIosPage = isMobile && pathname.startsWith(urls.iosApps);
  const shouldShowPermanentNotifications = !pathname.startsWith(urls.embedSetappMobile);

  return (
    <div className="app-layout-embedded">
      {shouldShowPermanentNotifications && (
        <div className="app-layout-embedded__permanent-notifications">
          <PermanentNotificationsContainer isEmbedded hideBannersOnIosPage={hideBannersOnIosPage} />
        </div>
      )}
      {children}
      <ModalRoot />
    </div>
  );
};


export default AppLayoutEmbedded;
